export default __webpack_public_path__ + "static/media/review-icon.c9a82f0b.svg";